import { render, staticRenderFns } from "./AgamResults.vue?vue&type=template&id=8df4bf10&scoped=true"
import script from "./AgamResults.vue?vue&type=script&lang=js"
export * from "./AgamResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df4bf10",
  null
  
)

export default component.exports